import React from 'react';
import { trackCheckoutStart } from '../lib/metaPixel';

/** The single checkout every purchase button leads to. */
export const CHECKOUT_URL = 'https://make-up-instructor-ready.impultienda.ar/checkout';
export const CURRENCY_NOTE = 'Payments are processed in your local currency';

/** Anchor of the offer block. */
export const OFFER_ANCHOR = '#offer-cta';
type CtaAction = 'checkout' | 'offer';
interface CtaButtonProps {
  label: string;
  /** 'checkout' opens the checkout; 'offer' scrolls to the offer block. */
  action?: CtaAction;
  className?: string;
}
export function CtaButton({
  label,
  action = 'offer',
  className = ''
}: CtaButtonProps) {
  const isCheckout = action === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : OFFER_ANCHOR} onClick={isCheckout ? trackCheckoutStart : undefined} className={`group inline-flex items-center justify-center gap-2.5 text-balance rounded-[14px] bg-brand-cta px-4 py-[18px] text-center font-body text-[13px] font-bold uppercase tracking-[0.02em] text-brand-cta-text shadow-[0_5px_0_0_#3A5538,0_18px_34px_-14px_rgba(72,103,70,0.7)] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-brand-cta-dark active:translate-y-[3px] active:shadow-[0_2px_0_0_#3A5538] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-cta focus-visible:ring-offset-2 focus-visible:ring-offset-brand-ivory sm:px-8 sm:text-[15px] sm:tracking-[0.06em] ${className}`} data-id="element-1" data-mp="vb0jscgcgulf">
      <span data-id="element-2" data-mp="3ou7cjuqqqal7">{label}</span>
      <span aria-hidden="true" className="hidden text-base font-normal transition-transform duration-200 ease-out group-hover:translate-x-1 sm:inline" data-id="element-3" data-mp="3sx3pb4tlnch8">
        →
      </span>
    </a>;
}
interface CtaBlockProps {
  label: string;
  action?: CtaAction;
  /** Small reassurance line under the button. */
  note?: string;
  className?: string;
}

/** Centered CTA block with the local-currency note above the button. */
export function CtaBlock({
  label,
  action = 'offer',
  note,
  className = ''
}: CtaBlockProps) {
  return <div className={`flex flex-col items-center text-center ${className}`} data-id="element-4" data-mp="3mxywdouv7trn">
      <p className="font-body text-[11px] uppercase tracking-[0.14em] text-brand-charcoal/50" data-id="element-5" data-mp="3hzf9nm8g6dy8">{CURRENCY_NOTE}</p>
      <CtaButton label={label} action={action} className="mt-4 w-full sm:w-auto sm:min-w-[420px]" data-id="element-6" data-mp="inxbcdu019o" />
      {note && <p className="mt-4 font-body text-[12px] uppercase tracking-[0.12em] text-brand-charcoal/55" data-id="element-7" data-mp="3rv8tlqohx9q1">{note}</p>}
    </div>;
}